export default __webpack_public_path__ + "22a9fa4ae6638eb4779e40533a266fbf.png";